import { render, staticRenderFns } from "./DistributionsExportForm.vue?vue&type=template&id=a04e282a&"
import script from "./DistributionsExportForm.vue?vue&type=script&lang=js&"
export * from "./DistributionsExportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports